import React, { Component } from "react";
import ChartistGraph from "react-chartist";
import { Grid, Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { Card } from "../../components/Card/Card.jsx";
import { StatsCard } from "../../components/StatsCard/StatsCard.jsx";



import { Query, Mutation } from "react-apollo";
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from "graphql-tag";
import { HttpLink } from 'apollo-link-http';

const restLink_account = new HttpLink({
  uri: "/api/v1/account/",
  credentials: 'include'
  });
const account_client = new ApolloClient({
 link: restLink_account,
 cache: new InMemoryCache(),
});

const restLink_cloud = new HttpLink({
  uri: "/api/v1/cloud/",
  credentials: 'include'
  });
const cloud_client = new ApolloClient({
 link: restLink_cloud,
 cache: new InMemoryCache(),
});

const COUNT_VM = gql`
{
  vms_count{
    count
  }
}
`;


const COUNT_VM_BY_POWER_STATUS = gql`
  query vms_count($power_state: String!){
    vms_count(power_state: $power_state) {
      count
    }
  }`;

const GET_PRODUCTS = gql`
{
  accountHasProduct_collection {
    accountHasProducts{
      id
      num
      product{
        id
        title
      }
    }
  }
}
`;


const GET_FLAVORS = gql`
{
  flavors_collections{
    flavors{
      id
      title
      description
      ram
      vcpu
    }
  }
}
`;

class Home extends Component {


  render() {


    return (
      <div className="content">
        <Grid fluid>
        
            
          <Query
              client={account_client}
              fetchPolicy='no-cache'
                query={gql`{
                  get_authenticated_user{
                    id
                    name
                    uid
                    account {
                      id
                      ContaAzulCustomerId
                    }
                  }
                }
                `}
            >
              {({ loading, error, data }) => {
                if (loading) return <div>Olá</div>;
                if (error) return <div>Erro :(</div>;

                  var get_authenticated_user = data.get_authenticated_user;
                  
                return  (

                  <div>
                    <Row>
                      <Col lg={12} sm={12}>
                        <strong>Olá, {get_authenticated_user.name}.</strong>
                      </Col>
                    </Row>

                  <Query
                    client={cloud_client}
                    fetchPolicy='no-cache'
                      query={gql`{
                        creditCard_collection{
                          creditCards{
                            id
                          }
                        }
                      }
                      `}
                  >
                    {({ loading, error, data }) => {
                      if (loading) return <div>Olá</div>;
                      if (error) return <div>Erro :(</div>;

                        var creditCards = data.creditCard_collection.creditCards;

                        return  <div>
                                    <strong>Seja bem vindo ao Movti Console</strong><br /><br />


                                </div>
                    
                }}
              </Query>
            </div>

            );
          }}
        </Query>
                  
            

            
          
        </Grid>
      </div>
    );
  }
}

export default Home;
